import React from "react";
import styled from "styled-components";
import { FiArrowDownRight, FiArrowUpRight, FiMinus } from "react-icons/fi";
import { colors } from "./colors";
import { METRICS, metricDelta, toneColors } from "./metrics";

const ICONS = { up: FiArrowUpRight, down: FiArrowDownRight, flat: FiMinus };

export default function MetricTabs({ active, current, previous, compareLabel, onChange }) {
    return (
        <Tabs role="tablist" aria-label="Chart metric">
            {METRICS.map((metric) => {
                const selected = metric.key === active;
                const delta = metricDelta(metric.key, current[metric.key], previous[metric.key]);
                const Icon = ICONS[delta.direction];
                return (
                    <Tab key={metric.key} type="button" role="tab" aria-selected={selected} $selected={selected} onClick={() => onChange(metric.key)}>
                        <Label $selected={selected}>{metric.label}</Label>
                        <Values>
                            <Value>{metric.formatValue(current[metric.key])}</Value>
                            <Delta $color={toneColors[delta.tone]}><Icon aria-hidden />{delta.text}</Delta>
                        </Values>
                        <Hidden>compared with {compareLabel}</Hidden>
                    </Tab>
                );
            })}
        </Tabs>
    );
}

const Tabs = styled.div`
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    border-top: 1px solid ${colors.line};
    border-bottom: 1px solid ${colors.line};
    @media (max-width: 900px) { grid-template-columns: repeat(2, 1fr); }
`;

const Tab = styled.button`
    position: relative;
    padding: 16px 20px;
    text-align: left;
    border: none;
    border-left: 1px solid ${colors.line};
    background: ${({ $selected }) => ($selected ? colors.surface : `${colors.canvas}99`)};
    cursor: pointer;
    transition: background 150ms;
    &:first-child { border-left: none; }
    &:hover { background: ${({ $selected }) => ($selected ? colors.surface : colors.canvas)}; }
    &::before {
        content: "";
        position: absolute;
        inset: 0 0 auto 0;
        height: 2px;
        background: ${({ $selected }) => ($selected ? colors.accent : "transparent")};
    }
    @media (max-width: 900px) {
        &:nth-child(odd) { border-left: none; }
        &:nth-child(n + 3) { border-top: 1px solid ${colors.line}; }
    }
`;

const Label = styled.span`
    display: block;
    font-size: 13px;
    font-weight: 500;
    color: ${({ $selected }) => ($selected ? colors.ink : colors.muted)};
`;

const Values = styled.span`
    display: flex;
    align-items: baseline;
    gap: 8px;
    margin-top: 4px;
`;

const Value = styled.span`
    font-size: 24px;
    font-weight: 600;
    letter-spacing: -0.01em;
    font-variant-numeric: tabular-nums;
    color: ${colors.ink};
`;

const Delta = styled.span`
    display: inline-flex;
    align-items: center;
    gap: 2px;
    font-size: 12px;
    font-weight: 500;
    font-variant-numeric: tabular-nums;
    color: ${({ $color }) => $color};
`;

const Hidden = styled.span`
    position: absolute;
    width: 1px;
    height: 1px;
    overflow: hidden;
    clip: rect(0 0 0 0);
`;
